<app-loading type='LOADING_DATA' *ngIf="this.api_result.Posting"></app-loading>
<div class="ui-g" *ngIf="!this.api_result.Posting && this.api_result.PromiseResult.success && this.patientData!=null">
    <div class="ui-g-12">
        <h2 class="boldnlabel">Basic details</h2>
        <div class="ui-g">
            <div class="ui-g-12 form-group basiccard">
                <div class="ui-g-12 ui-lg-6">
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">First Name:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="notranslate">
                                {{patientData.first_name}}
                            </p>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Last Name:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="notranslate">{{patientData.last_name}}</p>
                        </div>
                    </div>
                    <!-- <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Email:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>
                                {{patientData.user_patient.users.e_email}}
                            </p>
                        </div>
                    </div> -->
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Gender:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>{{patientData.gender | titlecase}}</p>
                        </div>
                    </div>
                </div>
                <div class="ui-g-12 ui-lg-6">
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Middle Name:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p class="notranslate">{{patientData.middle_name || 'N/A'}}</p>
                        </div>
                    </div>

                    <!-- <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Relation:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>{{patientData.relation | titlecase}}</p>
                        </div>
                    </div> -->

                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Date of Birth:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>{{patientData.date_of_birth | date:'longDate'}}</p>
                        </div>
                    </div>

                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">MRN Number:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-4">
                            <p class="notranslate">{{patientData.medical_record_number}}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="ui-g-12">
        <h2 class="boldnlabel">Address details</h2>
        <div class="ui-g">
            <div class="ui-g-12 form-group basiccard">
                <div class="ui-g-12 ui-lg-6">
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Address Line 1:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>{{patientData.address_line_1}}</p>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Address Line 2:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>{{patientData.address_line_2}}</p>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">City:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>{{patientData.city}}</p>
                        </div>
                    </div>
                </div>
                <div class="ui-g-12 ui-lg-6">
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">State:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>{{patientData.state_name}}</p>
                        </div>
                    </div>

                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Country:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>{{patientData.country.country_name}}</p>
                        </div>
                    </div>

                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-lg-4">
                            <label class="boldmedicalhistory" for="firstname">Zip Code:</label>
                        </div>
                        <div class="ui-g-12 ui-lg-8">
                            <p>{{patientData.zip_code}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

</div>


<app-error-messages [api_result]="this.api_result"></app-error-messages>